import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

import NavItem from './NavItem/NavItem';
import { useI18n } from '../../../../i18n/I18nProvider';

const Nav = styled.nav`display:flex;width:${({$mobile})=>$mobile?'100%':'auto'};`;
const List = styled.ul`
  display:flex;flex-direction:${({$mobile})=>$mobile?'column':'row'};align-items:${({$mobile})=>$mobile?'stretch':'center'};
  gap:${({$mobile})=>$mobile?'.35rem':'.12rem'};width:${({$mobile})=>$mobile?'100%':'auto'};margin:0;
  padding:${({$mobile})=>$mobile?'0':'.34rem'};border-radius:${({$mobile})=>$mobile?'0':'1.15rem'};
  background:${({$mobile})=>$mobile?'transparent':'#090909'};box-shadow:${({$mobile})=>$mobile?'none':'0 .65rem 1.6rem rgba(0,0,0,.13)'};
`;
const Label = ({ icon, children }) => <>{icon}<span>{children}</span></>;

const NavItems = ({ clicked, emailVerified, loggedIn, mobile, userType }) => {
  const { t } = useI18n();
  const items = [];

  if (loggedIn && emailVerified && userType === 'Client') {
    items.push(
      <NavItem key="demands" mobile={mobile} clicked={clicked} link="/demands"><Label icon={<AssignmentOutlinedIcon />}>{t('nav.clientDemands')}</Label></NavItem>,
      <NavItem key="projects" mobile={mobile} clicked={clicked} link="/projects"><Label icon={<HistoryOutlinedIcon />}>{t('nav.history')}</Label></NavItem>,
      <NavItem key="profile" mobile={mobile} clicked={clicked} link="/profile"><Label icon={<PersonOutlineIcon />}>{t('nav.profile')}</Label></NavItem>,
      <NavItem key="logout" mobile={mobile} clicked={clicked} link="/logout"><Label icon={<LogoutOutlinedIcon />}>{t('nav.logout')}</Label></NavItem>,
    );
  } else if (loggedIn && emailVerified && userType === 'Artisan') {
    items.push(
      <NavItem key="jobs" mobile={mobile} clicked={clicked} link="/jobs"><Label icon={<AssignmentOutlinedIcon />}>{t('nav.missions')}</Label></NavItem>,
      <NavItem key="planning" mobile={mobile} clicked={clicked} link="/planning"><Label icon={<CalendarMonthOutlinedIcon />}>{t('nav.planning')}</Label></NavItem>,
      <NavItem key="newjobs" mobile={mobile} clicked={clicked} link="/newjobs"><Label icon={<ExploreOutlinedIcon />}>{t('nav.explore')}</Label></NavItem>,
      <NavItem key="boutique" mobile={mobile} clicked={clicked} link="/boutique"><Label icon={<StorefrontOutlinedIcon />}>{t('nav.showcase')}</Label></NavItem>,
      <NavItem key="profile" mobile={mobile} clicked={clicked} link="/profileartisan"><Label icon={<PersonOutlineIcon />}>{t('nav.profile')}</Label></NavItem>,
      <NavItem key="logout" mobile={mobile} clicked={clicked} link="/logout"><Label icon={<LogoutOutlinedIcon />}>{t('nav.logout')}</Label></NavItem>,
    );
  } else if (loggedIn && !emailVerified) {
    items.push(
      <NavItem key="verify" mobile={mobile} clicked={clicked} link="/verify-email"><Label icon={<PersonOutlineIcon />}>{t('nav.verifyEmail')}</Label></NavItem>,
      <NavItem key="logout" mobile={mobile} clicked={clicked} link="/logout"><Label icon={<LogoutOutlinedIcon />}>{t('nav.logout')}</Label></NavItem>,
    );
  } else {
    items.push(
      <NavItem key="login" mobile={mobile} clicked={clicked} link="/login"><Label icon={<LoginOutlinedIcon />}>{t('nav.login')}</Label></NavItem>,
      <NavItem key="signup" mobile={mobile} clicked={clicked} link="/signup"><Label icon={<PersonAddAltOutlinedIcon />}>{t('nav.signup')}</Label></NavItem>,
    );
  }

  return <Nav aria-label="Navigation principale" $mobile={mobile}><List $mobile={mobile}>{items}</List></Nav>;
};

const mapStateToProps = ({ firebase }) => ({
  userType: firebase.profile && firebase.profile.user_type,
  emailVerified: Boolean(firebase.auth && firebase.auth.emailVerified),
});
export default connect(mapStateToProps)(NavItems);
